import { isHelixOnlyHub } from 'utils/helix';
import { hasPrivilege, HELIX_READ, SETTINGS_WRITE, USER_READ } from 'utils/privileges';
import config from 'utils/config';
export var COACH_AI_ROUTE = '/coach-ai';
export var PLATFORM_ANNOUNCEMENTS_ROUTE = '/platform-announcements';
export var PLATFORM_ANNOUNCEMENTS_EDITOR_ROUTES = {
  root: '/platform-announcements-manager',
  new: '/platform-announcements-manager/new',
  single: '/platform-announcements-manager/:announcementId'
};
export var MEETING_REPROCESSING_ROUTES = {
  root: '/meetings',
  single: '/meetings/:meetingId'
};
export var EMAIL_SUPPRESSIONS_ROUTES = {
  root: '/email-suppressions'
};
export var COMPLETION_STATUS_ROUTES = {
  root: '/completion-status-editor',
  review: '/completion-status-editor/review',
  success: '/completion-status-editor/success'
};
export var LOGS_ROUTES = {
  content: '/logs/contents',
  message: '/logs/messages',
  nudge: '/logs/nudges',
  team: '/logs/teams',
  userImport: '/logs/user-imports',
  user: '/logs/users',
  skills: '/logs/skills'
};
export var SKILLS_ANALYTICS_ROUTES = {
  root: '/skills-analytics'
};
export var SKILL_ROUTES = {
  root: '/skills',
  newSet: '/skills/newSet'
};
export var PEOPLE_ROUTES = {
  root: '/people',
  skills: '/people/:userId/skills',
  skillsSkill: '/people/:userId/skills/:skillId',
  skillsMeeting: '/people/:userId/skills/meeting/:meetingId'
};
export var PROFILE_ROUTES = {
  root: '/profile',
  badges: '/profile/badges',
  playlists: '/profile/playlists',
  assets: '/profile/assets',
  upcoming: '/profile/upcoming',
  saved: '/profile/saved',
  history: '/profile/history',
  skills: '/profile/skills',
  skillsSkill: '/profile/skills/:skillId',
  skillsMeeting: '/profile/skills/meeting/:meetingId'
};

// A Helix-only hub has no learning content, so /home is not a page there.
export var HUB_HOME_ROUTE = isHelixOnlyHub ? PROFILE_ROUTES.skills : '/home';
export var MY_TEAMS_ROUTES = {
  root: '/my-teams',
  member: '/my-teams/people/:userId',
  team: '/my-teams/:teamId',
  teamTrends: '/my-teams/:teamId/trends',
  teamPeople: '/my-teams/:teamId/people',
  teamMember: '/my-teams/:teamId/people/:userId',
  teamReports: '/my-teams/:teamId/reports',
  teamReport: '/my-teams/:teamId/reports/:reportId',
  teamPlaylists: '/my-teams/:teamId/playlists'
};
export var DEFAULT_ADMIN_PAGE_ROUTE = function () {
  if (!isHelixOnlyHub) {
    return '/home';
  }

  // Helix-only hub logic
  if (config.helixAdminSkillsAnalyticsPage !== false && hasPrivilege(HELIX_READ)) {
    return SKILLS_ANALYTICS_ROUTES.root;
  }
  if (hasPrivilege(USER_READ)) {
    return '/users';
  }
  if (hasPrivilege(SETTINGS_WRITE)) {
    return SKILL_ROUTES.root;
  }
  return '/home';
}();